import PropTypes from "prop-types";
import clsx from "clsx";
import GiveawayCard from "./GiveawayCard"; // Updated import
import moment from "moment-timezone";
import { useAppSelector } from "../../hooks/useReduxMethods";
import { getUserPrefersLang } from "../../shared/helpersMethod";

moment.tz.add([
  "Asia/Baghdad|LMT BGT +03|-3A.Q -3A -30|012|-2ldXH.Q 1nzD.Q 8Hz0|67e5",
]);

const FeatureIconFour = ({
  spaceTopClass,
  spaceBottomClass,
  containerClass,
  gutterClass,
  responsiveClass,
  bottomText,
  bgImg,
}) => {
  const { bussinessData } = useAppSelector((state) => state.bussinessData);
  const userLng = getUserPrefersLang();

  return (
    <div
      className={clsx(
        "support-area hm9-section-padding pt-40 pl-20 pr-20",
        spaceTopClass,
        spaceBottomClass,
        responsiveClass
      )}
      style={{ background: "var(--slider-background-color)" }}
    >
      <div className={clsx(containerClass, gutterClass)}>
        <div className="row- d-flex justify-content-center gap-4 flex-wrap align-items-center">
          {bussinessData?.countDown?.map((single, key) => {
            console.log("Countdown item:", single); // Debug log
            return (
              <div key={key} className="countdown-item">
                <GiveawayCard
                  image={
                    single.type === "car" || single.type === "mobile"
                      ? single.type === "car"
                        ? require("../../assets/images/count-down/count-down-car.png")
                        : require("../../assets/images/count-down/count-down-phone.png")
                      : require("../../assets/images/count-down/count-down-phone.png")
                  }
                  title={single.title[userLng]}
                  countdownData={single} // Pass the entire countdown object
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

FeatureIconFour.propTypes = {
  bgImg: PropTypes.string,
  containerClass: PropTypes.string,
  gutterClass: PropTypes.string,
  responsiveClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

export default FeatureIconFour;
